import { format, isBefore } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import * as Yup from 'yup';

export const rebuildRideValidationSchema = (timeZone) =>
  Yup.object().shape({
    timeAnchor: Yup.string().required('Required Field'),
    anchorTime: Yup.lazy(() => {
      const minDate = new Date(new Date().setHours(0, 0, 0, 0));

      return Yup.date()
        .min(minDate, 'Ride date cannot be in the past.')
        .nullable()
        .required('Required Field')
        .typeError('Ride date is not a valid date');
    }),
    time: Yup.lazy(() => {
      return Yup.mixed()
        .required('Required Field')
        .when(['anchorTime', 'time'], (anchorTime, time) => {
          if (!time) {
            return Yup.string();
          }
          const currentDateTime = utcToZonedTime(new Date().toISOString(), timeZone);
          const datePart = format(new Date(anchorTime), 'yyyy-MM-dd');
          const enteredDateTime = new Date(`${datePart}T${time}`);

          return isBefore(enteredDateTime, currentDateTime)
            ? Yup.date().typeError('time cannot be in the past.')
            : Yup.string();
        });
    }),
    waypointsAttributes: Yup.array()
      .min(1)
      .of(
        Yup.object().shape({
          anchor: Yup.boolean().required(),
          id: Yup.number().required(),
          passengerIdsStrings: Yup.array().min(1, 'Required Field').of(Yup.string()),
          accountLocationAttributes: Yup.object().shape({
            address: Yup.string().required('Required Field'),
            accountId: Yup.number().required('Required Field'),
            placeId: Yup.string().required('Required Field'),
          }),
        })
      ),
  });
